import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Input, OnDestroy, Inject } from '@angular/core';

const GRAPH_ENDPOINT = 'https://graph.microsoft.com/v1.0/me';

type ProfileType = {
  givenName?: string,
  surname?: string,
  userPrincipalName?: string,
  id?: string,
  mail?: string
}

@Component({
  selector: 'unity',
  templateUrl: './unity.component.html',
  styleUrls: ['./unity.component.css']
})
export class UnityComponent implements OnInit, OnDestroy {

  profile!: ProfileType;
  gameInstance: any;
  progress = 0;
  isReady = false;

  @Input() version: number = 3;
  build: any;
  cont_build: any;

  constructor(
    private http: HttpClient,
    @Inject(DOCUMENT) private document: any
  ) { }

  ngOnInit(): void {
    this.getProfile();
    const loader = (window as any).UnityLoader;
    this.gameInstance = loader.instantiate('gameContainer1', `./assets/Build/BuildQuimica.json`, {
      onProgress: (gameInstance: any, progress: number) => {
        this.progress = progress;
        if (progress === 1) {
          this.isReady = true;
          this.setName(this.profile);
        }
      }
    });

    this.build = document.getElementById("unity");
    this.cont_build = document.getElementById("gameContainer1");
  }

  ngOnDestroy(): void {
    this.gameInstance.Quit();
  }

  setName(profile?:ProfileType) {
    this.gameInstance.SendMessage('JavascriptHook', 'SetNombre',profile.givenName + " " + profile.surname);
    this.gameInstance.SendMessage('JavascriptHook', 'SetCorreo',profile.mail);
  }

  getProfile() {
    this.http.get(GRAPH_ENDPOINT)
      .subscribe(profile => {
        console.log("datos_usuario=" + JSON.stringify(profile));
        this.profile = profile;
      });
  }

  openFullscreen() {
    if (this.build.requestFullscreen) {
      this.build.style.width = "100px";
      this.cont_build.requestFullscreen();
    } else if (this.build.mozRequestFullScreen) {
      /* Firefox */
      this.build.mozRequestFullScreen();
    } else if (this.build.webkitRequestFullscreen) {
      /* Chrome, Safari and Opera */
      this.build.webkitRequestFullscreen();
    } else if (this.build.msRequestFullscreen) {
      /* IE/Edge */
      this.build.msRequestFullscreen();
    }
  }

}
